<lib-language-selector-ui
  [languages]="availableLanguages"
  [currentLanguage]="currentLanguage()"
  (currentLanguageChange)="setCurrentLang($event)"
></lib-language-selector-ui>
